var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAirDistributionFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / FocusPosition-dummy--normal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,38.4185495 C24.9264177,38.7935194 25.9390815,39 27,39 C31.4185,39 35,35.4185 35,31 C35,26.5815 31.4185,23 27,23 C25.9390815,23 24.9264177,23.2064806 24,23.5814505 C23.0735823,23.2064806 22.0609185,23 21,23 C16.5815,23 13,26.5815 13,31 C13,35.4185 16.5815,39 21,39 C22.0609185,39 23.0735823,38.7935194 24,38.4185495 Z M0,0 L48,0 L48,43 L0,43 L0,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--\\u21B3-Icons---\\u2660\\uFE0F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-FocusPosition-dummy--normal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mask"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    mask: "url(#mask-2)",
    x: 15,
    y: 21,
    width: 18,
    height: 28,
    rx: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    mask: "url(#mask-2)",
    cx: 24,
    cy: 11,
    r: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.000000, 25.000000)",
    fill: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,6 C18,9.313875 15.313875,12 12,12 C8.686125,12 6,9.313875 6,6 C6,2.686125 8.686125,0 12,0 C15.313875,0 18,2.686125 18,6 Z",
    id: "circle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6 C12,9.313875 9.313875,12 6,12 C2.686125,12 0,9.313875 0,6 C0,2.686125 2.686125,0 6,0 C9.313875,0 12,2.686125 12,6 Z",
    id: "circle"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-dummy-icon",
    stroke: "#FF6666",
    strokeDasharray: "2,3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L44,44",
    id: "Line",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L44,44",
    id: "Line-Copy",
    strokeWidth: 2,
    transform: "translate(22.000000, 22.000000) scale(-1, 1) translate(-22.000000, -22.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAirDistributionFocus);
export default __webpack_public_path__ + "static/media/icon-air_distribution_focus.c8bf194fea26fc4aedd662b4eb9cec06.svg";
export { ForwardRef as ReactComponent };